class VultureCollectionFilters {
  constructor() {
    this.container = document.querySelector('.vulture-collection-grid');
    this.form = document.getElementById('vultureFilterForm');
    this.sortSelect = document.getElementById('vulture-sort-select');
    this.drawer = document.getElementById('VultureFilterDrawer');
    this.toggleBtns = document.querySelectorAll('#vulture-filter-toggle');
    this.closeBtns = document.querySelectorAll('.drawer-close');
    this.loader = document.getElementById('vulture-collection-loader');
    this.clearAllBtn = document.getElementById('vulture-filter-clear-all');
    
    // Fallback for missing elements
    if (!this.container || !this.form) return;

    this.bindEvents();
    this.updateActiveFilterCount();
  }

  bindEvents() {
    // Global Interaction Delegation (Handles toolbar swaps)
    document.addEventListener('click', (e) => {
      // Drawer Toggle
      const toggleBtn = e.target.closest('#vulture-filter-toggle');
      if (toggleBtn) {
        e.preventDefault();
        this.openDrawer();
      }

      // Drawer Closure
      if (this.drawer && this.drawer.classList.contains('is-open')) {
        const closeBtn = e.target.closest('#vulture-drawer-close');
        if (closeBtn || e.target === this.drawer) {
          e.preventDefault();
          this.closeDrawer();
        }
      }

      // Clear Filters
      const clearBtn = e.target.closest('.drawer-clear-btn');
      if (clearBtn) {
        e.preventDefault();
        this.clearFilters(clearBtn.href);
      }
    });

    // Form Change / AJAX Fetch
    this.form.addEventListener('input', this.debouncedSubmit.bind(this));
    
    // Sort Sync (Delegated)
    document.addEventListener('change', (e) => {
      if (e.target.id === 'vulture-sort-select') {
        const hiddenSort = this.form.querySelector('input[name="sort_by"]');
        if (hiddenSort) hiddenSort.value = e.target.value;
        this.onSubmit();
      }
    });

    // Popstate (Browser Back/Forward)
    window.addEventListener('popstate', (e) => {
      if (e.state && e.state.searchParams) {
        this.fetchFilteredHTML(e.state.searchParams);
      }
    });
  }

  openDrawer() {
    if (!this.drawer) return;
    this.drawer.style.display = 'block';
    // Small delay to allow display:block to hit the DOM before animation class
    requestAnimationFrame(() => {
      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  closeDrawer() {
    if (!this.drawer) return;
    console.log("Vulture Debug: Executing closeDrawer()");
    this.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    
    // Wait for the 350ms transition
    setTimeout(() => {
      if (!this.drawer.classList.contains('is-open')) {
        this.drawer.style.display = 'none';
      }
    }, 400);
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  debouncedSubmit = this.debounce((e) => {
    this.onSubmit();
  }, 500);

  onSubmit() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    this.updateURL(searchParams);
    this.fetchFilteredHTML(searchParams);
  }

  clearFilters(url) {
    if (!url) return;
    const urlObj = new URL(url, window.location.origin);
    const searchParams = urlObj.searchParams.toString();
    this.updateURL(searchParams);
    this.fetchFilteredHTML(searchParams);
  }

  updateURL(searchParams) {
    const url = `${window.location.pathname}?${searchParams}`;
    window.history.pushState({ searchParams }, '', url);
  }

  async fetchFilteredHTML(searchParams) {
    this.startLoading();
    
    // Use Shopify Section Rendering API
    // Request only the HTML for this specific section to reduce bandwidth
    const fetchUrl = `${window.location.pathname}?section_id=vulture-main-collection&${searchParams}`;

    try {
      const response = await fetch(fetchUrl);
      const text = await response.text();
      this.renderFromHTML(text);
    } catch (err) {
      console.error("Vulture Tactical Error: Failed to fetch collection filters", err);
    } finally {
      this.stopLoading();
    }
  }

  renderFromHTML(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    // Swap the main grid
    const targetGridInner = document.getElementById('vulture-product-grid-inner');
    const sourceGridInner = doc.getElementById('vulture-product-grid-inner');
    
    // Swap pagination if it exists
    const gridContainer = document.getElementById('VultureCollectionProductGrid');
    const newGridContainer = doc.getElementById('VultureCollectionProductGrid');
    
    if (gridContainer && newGridContainer) {
      gridContainer.innerHTML = newGridContainer.innerHTML;
      // Re-assign the loader reference since we blew away the DOM inside gridContainer
      this.loader = document.getElementById('vulture-collection-loader');
    }

    // Swap the internal filter form to update active states (checked boxes, counters)
    const currentForm = this.form;
    const newForm = doc.getElementById('vultureFilterForm');
    if (currentForm && newForm) {
      currentForm.innerHTML = newForm.innerHTML;
    }

    // Swap Top Level Toolbar to update visual sort label
    const currentToolbar = document.getElementById('vulture-collection-toolbar');
    const newToolbar = doc.getElementById('vulture-collection-toolbar');
    if (currentToolbar && newToolbar) {
      currentToolbar.innerHTML = newToolbar.innerHTML;
    }

    // Swap Top Level "Clear All" or other headers if needed
    const currentClearBtn = document.getElementById('vulture-filter-clear-all');
    const newClearBtn = doc.getElementById('vulture-filter-clear-all');
    if (currentClearBtn && newClearBtn) {
      currentClearBtn.outerHTML = newClearBtn.outerHTML;
    }

    this.updateActiveFilterCount();
  }

  updateActiveFilterCount() {
    let count = 0;
    const checkboxes = this.form.querySelectorAll('input[type="checkbox"]:checked');
    count += checkboxes.length;

    // Check if price inputs have values different than empty
    const numberInputs = this.form.querySelectorAll('input[type="number"]');
    numberInputs.forEach(input => {
      if (input.value && input.value !== "") count++;
    });

    const activeCountSpan = document.getElementById('vulture-active-filter-count');
    if (activeCountSpan) {
      if (count > 0) {
        activeCountSpan.textContent = `[${count} ACTIVE]`;
        activeCountSpan.classList.remove('hidden');
      } else {
        activeCountSpan.classList.add('hidden');
      }
    }
  }

  startLoading() {
    if (this.loader) {
      this.loader.classList.remove('opacity-0', 'pointer-events-none');
    }
    const innerGrid = document.getElementById('vulture-product-grid-inner');
    if (innerGrid) innerGrid.classList.add('opacity-50');
  }

  stopLoading() {
    if (this.loader) {
      this.loader.classList.add('opacity-0', 'pointer-events-none');
    }
    const innerGrid = document.getElementById('vulture-product-grid-inner');
    if (innerGrid) innerGrid.classList.remove('opacity-50');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.vultureCollection = new VultureCollectionFilters();
});
